import { AttendService } from '@/user/apis/attend/attend.api'
import Cookies from 'js-cookie'

export default {
  namespaced: true,
  state: () => ({
    monthlyLectures: null,
    lectureInfo: null,
    lectureDesc: null,
    selectLectureId: Cookies.get('EDU_ATTEND_SELECTED_LECTURE_ID'),
  }),
  mutations: {
    monthlyLectures(state, value) {
      state.monthlyLectures = value
    },
    lectureInfo(state, value) {
      state.lectureInfo = value
    },
    lectureDescription(state, value) {
      state.lectureDesc = value
    },
    selectLectureId(state, value) {
      Cookies.set('EDU_ATTEND_SELECTED_LECTURE_ID', value)
      state.selectLectureId = value
    },
    clearMonthlyLectures(state) {
      state.monthlyLectures = null
    },
  },
  actions: {
    async getMonthlyLectures({ commit }, params) {
      try {
        const data = await AttendService.getLectures(params)
        commit('monthlyLectures', data)
      } catch (e) {
        // error
      }
    },
    async selectLecture({ state, commit }, id) {
      try {
        const info = await AttendService.getLectureInfo(id ? id : state.selectLectureId)
        commit('lectureInfo', info)
        const desc = await AttendService.getLectureDescription(id ? id : state.selectLectureId)
        commit('lectureDescription', desc)
      } catch (e) {
        commit('lectureInfo', null)
        commit('lectureDescription', null)
      }
    },
    async lectureAttender({ state }, params) {
      try {
        const data = await AttendService.attenders(state.selectLectureId, params)
        return { isSuccess: true, data: data }
      } catch (e) {
        return { isSuccess: false, data: e.response.data.message }
      }
    },
  },
  getters: {
    monthlyLectures(state) {
      return state.monthlyLectures
    },
    lectureInfo(state) {
      return state.lectureInfo
    },
    lectureDescription(state) {
      return state.lectureDesc
    },
    selectLectureId(state) {
      return state.selectLectureId
    },
  },
}
